import { Box, Button, Typography } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

function CustomHead({siteMeta, setSiteMeta, onSave  }) {

    const handleChange = (e) => {
        setSiteMeta({
            ...siteMeta,
            [e.target.name]: e.target.value,
        });
    };

  return <Box sx={{minWidth: 600}}>  
    <ValidatorForm onSubmit={onSave}>
      <Typography variant="h6">Custom Head (Optional)</Typography>
      <Typography gutterBottom>
        If set this will insert in the head section of every page.
      </Typography>
      <Box my={2}>
        <TextValidator  
          fullWidth 
          name="head" 
          label="Custom Head HTML" 
          variant="outlined" 
          multiline 
          rows={15} 
          rowsMax={20} 
          value={siteMeta.head} 
          onChange={handleChange}
          style={{
            fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
            fontSize: '14px',
            lineHeight: '1.5',
            backgroundColor: '#f5f5f5',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            padding: '12px',
          }}
          InputProps={{
            style: {
              fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
              fontSize: '14px',
              lineHeight: '1.5',
            }
          }}
        />
      </Box>
      <Button variant="contained" color="primary" type="submit">
          Save Head Content
      </Button>
    </ValidatorForm>
  </Box>;
}

export default CustomHead;